export const APP_NAME = "Living Wire";
export const TOKEN_KEY = "lw.token";
export const MESSAGE_SENT_KEY = "lw.messageSent";
export const LANGUAGES_KEY = "living_wire.languages";
export const PREFERRED_LANGUAGE_KEY = "living_wire.preferred_language";
export const SHOW_DRAFTS_KEY = "living_wire.show_drafts";
